import { Pipe, PipeTransform } from '@angular/core';
import { Observable, interval, map } from 'rxjs';

/** v8 ignore: Angular decorator metadata creates false-positive uncovered branches in v8 coverage. */
/* v8 ignore start */
@Pipe({
  name: 'secondsCounter',
  standalone: true
})
export class SecondsCounterPipe implements PipeTransform {
  /* v8 ignore stop */
  /** Returns an observable emitting elapsed seconds since the given start time. */
  public transform(value: Date | number): Observable<number> {
    const startTime = value instanceof Date ? value : new Date(value);

    return interval(100) // Emit every second
      .pipe(
        map(() => (new Date().getTime() - startTime.getTime()) / 1000) // Calculate elapsed seconds,
      );
  }
}
